module.exports = __webpack_public_path__ + "img/img03_text.107cc909.png";